import React, { useEffect, useState } from 'react';
import { openMessengerApp } from './utils';

const SelectWhatsappModal = (props) => {
    const [formattedPhoneNumber, setFormattedPhoneNumber] = useState(props.phoneNumber);

    useEffect(() => {
        if(props?.phoneNumber) {
            const cleaned = ('' + props.phoneNumber).replace(/\D/g, '');
            const match = cleaned.match(/^(\d{1,3})(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                const intlCode = (match[1] ? '+' + match[1] + ' ' : '');
                setFormattedPhoneNumber([intlCode, '(', match[2], ') ', match[3], '-', match[4]].join(''));
            } else {
                setFormattedPhoneNumber(props.phoneNumber);
            }
        }
    }, [props.phoneNumber]);

    return (
        <div style={{ display: props?.show ? 'block' : 'none' }} className='a-modal-container'>
            <div className="a-modal-overlay" onClick={() => props?.onClose(false)}></div>
            <div className="a-modal">
                
                <h2 className="lucky-font">Text Us on WhatsApp to get Started</h2>
                
                <div className='a-modal-body lato-font'>
                    <>
                        <div>
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '10px' }}>
                                <div
                                    onClick={() => props.openMessengerApp ? props.openMessengerApp() : openMessengerApp("english", "whatsapp", true)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className='whatsapp-btn'>
                                    <img src='/img/whatsapp.svg' /> Open to WhatsApp
                                </div>
                                <a
                                    href="https://www.whatsapp.com/download/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className='download-whatsapp-btn'
                                >
                                    <span>⬇️</span> Download WhatsApp
                                </a>
                            </div>
                            {props?.phoneNumber && (
                                <div className='number'>
                                    <strong
                                        onClick={() => props.openMessengerApp ? props.openMessengerApp() : openMessengerApp("english", "whatsapp", true)}
                                    >{formattedPhoneNumber}</strong>
                                </div>
                            )}
                        </div>
                    </>
                </div>
            </div>
        </div>
    );

};

export default SelectWhatsappModal;